import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { setUserContext, clearUserContext } from '../sentry';
import useIsLoggedIn from './useIsLoggedIn';

export const useSentryUser = () => {
  const currentUser = useSelector((state: RootState) => state.user);
  const isLoggedIn = useIsLoggedIn();
  useEffect(() => {
    if (isLoggedIn && currentUser) {
      setUserContext({
        id: currentUser?._id,

        username: currentUser.username,
      });
    } else {
      clearUserContext();
    }
  }, [currentUser, isLoggedIn]);
};

export default useSentryUser;
